import styled from 'styled-components';

const PMT_MAX_WIDTH = 1160;
const LEFT_SECTION_MAX_WIDTH = 352;
const RIGHT_SECTION_MAX_WIDTH = 735;

const PMTContainer = styled.div.attrs({ className: 'content-container' })(({ theme }) => ({
  width: '100%',
  maxWidth: PMT_MAX_WIDTH,
  position: 'relative',

  [`${theme.mediaBreakpointUp.lg}`]: {
    margin: 'auto',
    paddingLeft: theme.spacing[20],
    paddingRight: theme.spacing[20],
  },
}));

export const LayoutContainer = styled(PMTContainer)<{ minHeight?: number }>(({ theme, minHeight = 0 }) => ({
  [`${theme.mediaBreakpointUp.lg}`]: {
    paddingTop: theme.spacing[24],
    paddingBottom: theme.spacing[24],
    minHeight: minHeight,
  },
}));

export const LeftSection = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  ['& > *:not(:last-child)']: {
    marginBottom: theme.spacing[24],
  },
  [`${theme.mediaBreakpointUp.lg}`]: {
    flex: `0 0 ${LEFT_SECTION_MAX_WIDTH}px`,
    maxWidth: LEFT_SECTION_MAX_WIDTH,
  },
}));

// Fixme: overflow: hidden is a temporary fix for TrackingDetails overflowing RightSection, Chrome only
export const RightSection = styled.div(({ theme }) => ({
  ['& > *:not(:last-child)']: {
    marginBottom: 0,
  },
  [`${theme.mediaBreakpointUp.lg}`]: {
    flex: 1,
    maxWidth: RIGHT_SECTION_MAX_WIDTH,
    marginLeft: theme.spacing[32],
  },
}));

export const InnerLayoutContainer = styled.div(({ theme }) => ({
  [`${theme.mediaBreakpointUp.lg}`]: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));
